<template>
  <div class="train-list-page bg">
    <div class="train-box" v-if="trainTypeList.length > 0">
      <div class="train-container">
        <div v-for="(obj, j) in trainList" :key="j" class="single">
          <div
            :class="{ content: true, disHover: lock }"
            @mouseover="lock ? disHover() : handleHover(j)"
            @mouseleave="lock ? disHover() : handleLeave()"
          >
            <div class="img"><img :src="iconUrl(obj)" /></div>
            <p class="name">
              <span class="trainName">{{ obj.trainName }}</span>
              <span class="trainType" v-html="typeName(obj.trainType)"></span>
            </p>
            <div class="hoverDiv" v-if="hoverDiv && hoverIndex === j">
              <el-button round @click="startTrain(obj)">开始训练</el-button>
            </div>
            <div v-if="lock" class="expire-box">
              <img src="../assets/images/lock.png" />
            </div>
            <!-- 到店和高级 需要判断是否到期 openDay useDay -->
          </div>
        </div>
      </div>
    </div>
    <div class="movie-box" v-else>
      <div class="movie-container">
        <div class="movie-type" v-for="(item, index) in movies" :key="index">
          <h4 class="movie-title">{{ item.title }}</h4>
          <div class="movie-content">
            <div
              class="detail"
              v-for="(movie, key) in item.data"
              :key="key"
              @click="toProgram(movie.src)"
            >
              <!--
                <video id="video" :src="movie.src" @play="paly" :poster="movie.cover" controls></video>
              -->
              <div
                class="cover"
                :style="`background-image: url('${movie.cover}')`"
              ></div>
              <p class="name">{{ movie.name }}</p>
              <div class="play"><img src="../assets/images/play.png" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="trainFrame"
      :visible.sync="trainVisible"
      v-if="trainVisible"
      fullscreen
      :show-close="false"
    >
      <div slot="title" class="iframe-btn-box" @click.self="catchClick">
        <span class="timing">{{ minandsec }}</span>
        <span class="close" @click.stop="stopConfirm">
          <i class="el-icon-circle-close-outline"></i>退出
        </span>
      </div>
      <div id="game-frame">
        <div
          id="loading-box"
          v-loading="loading"
          element-loading-text="拼命加载中"
          v-if="loading"
        ></div>
        <iframe
          id="game"
          ref="iframe"
          v-on:load="loadingDone"
          :src="trainPath"
          allowfullscreen
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getAllTrainList, saveTrainRecord, getDailyTrainTime } from '@api/train'
import { getDuration } from '@utils'
import { type } from '@src/constant/train'
import { movies } from '@src/constant/nav'
import screenfull from 'screenfull'
import { namespace } from 'vuex-class'

const moduleTrain = namespace('train')
const moduleUser = namespace('user')

@Component
export default class Rs extends Vue {
  @Prop(Array) trainTypeList

  // 下一页 上一页数据
  num = 0
  len = ''
  preState = false
  nextState = true
  predisabled = true
  nextdisabled = false
  trainPath = ''
  // 训练列表
  trainList = []
  hoverDiv = false
  hoverIndex = ''
  typeList = type
  movies = movies

  // ifram
  trainVisible = false
  loading = true
  isFullscreen = false
  start_time = 0
  id = undefined
  // 秒表计时器
  minandsec = '00:00'
  timer = null

  // @moduleTrain.Getter curTrainTypeInfo
  @moduleTrain.Getter curTrain
  @moduleTrain.Mutation SET_CUR_TRAIN
  @moduleUser.Getter openDay
  @moduleUser.Getter usedDay
  // @moduleUser.Getter dailyTrainDuration
  // @moduleUser.Getter singleTrainDuration

  get lock() {
    return this.usedDay > this.openDay
  }
  @Watch('trainTypeList')
  onTrainTypeListChanged() {
    this._getAllTrainList()
  }

  created() {
    this._getAllTrainList()
  }
  toProgram(src) {
    console.log('去掉screenfull')
    // screenfull.request()
    window.open(src)
  }

  disHover() {
    console.log('您已到期')
  }
  handleHover(j) {
    this.hoverDiv = true
    this.hoverIndex = j
  }
  handleLeave() {
    this.hoverDiv = false
    this.hoverIndex = ''
  }

  async _getAllTrainList() {
    const res = await getAllTrainList()
    this.trainList = res.filter(item => {
      return this.trainTypeList.includes(item.trainType)
    })
    this.len = this.trainList.length
  }

  async _afterIframeLoaded() {
    this.showTiming()
    try {
      const params = {
        id: this.id,
        trainId: this.curTrain.trainId,
        trainName: this.curTrain.trainName,
      }
      const res = await saveTrainRecord(params)
      this.id = res.data.id
    } catch (error) {
      console.log(error)
    }
  }
  handlePre() {
    if (this.num <= this.len - 1 && this.num !== 0) {
      this.num--
      this.predisabled = this.num === 0 ? true : false
      this.nextdisabled = this.num <= this.len - 1 ? false : true
    }
    console.log('pre', this.num)
  }
  handleNext() {
    this.num = this.num + 1
    this.nextdisabled = this.num >= this.len - 1 ? true : false
    this.predisabled = this.num <= this.len - 1 ? false : true
    console.log('next', this.num)
  }
  iconUrl(train) {
    return `images/traintype/train_${train.trainType}.png`
  }
  typeName(traintype) {
    const target = this.typeList.find(item => item.type === traintype)
    return target ? target.name : ''
  }

  // 开始计时
  showTiming() {
    let digital = 0
    clearInterval(this.timer)
    this.timer = setInterval(() => {
      digital++
      let m = parseInt(digital / 60)
      let s = parseInt(digital % 60)
      this.minandsec = this.toDub(m) + ':' + this.toDub(s)
      // if (digital === this.singleTrainDuration * 60) {
      //   this.$confirm(
      //     `根据您的病历情况，每次训练时间不宜超过${
      //       this.singleTrainDuration
      //     }分钟，休息一会吧。`,
      //     '专家建议',
      //     {
      //       confirmButtonText: '取消',
      //       cancelButtonText: '确定',
      //       type: 'warning',
      //     }
      //   )
      //     .then(() => this.$message('继续训练'))
      //     .catch(() => this.stopTrain(this.hide))
      // }
    }, 1000)
  }
  // 时间补零
  toDub(time) {
    return time < 10 ? '0' + time : '' + time
  }
  // 全屏
  handleFullscreen() {
    if (!screenfull.enabled) {
      // T5 还判断了是否为客户端
      console.log('FullScreen:you browser can not work')
      return false
    }
    if (this.isFullscreen) {
      screenfull.exit()
      this.isFullscreen = false
    } else {
      screenfull.request()
      this.isFullscreen = true
    }
  }
  async startTrain(train) {
    const res = await getDailyTrainTime()
    console.log(res, '每天训练限时')
    // if (res.data >= this.dailyTrainDuration * 60) {
    //   this.$confirm(
    //     `根据您的病历情况，每天训练时间不宜超过${
    //       this.dailyTrainDuration
    //     }分钟，明天再来吧。`,
    //     '专家建议',
    //     {
    //       confirmButtonText: '确定',
    //       type: 'warning',
    //     }
    //   )
    //     .then(() => {})
    //     .catch(() => {})
    // } else {
    console.log(this.hoverDiv)
    this.id = undefined
    this.trainVisible = true
    this.loading = true
    this.minandsec = '00:00'
    this.handleFullscreen()
    this.SET_CUR_TRAIN(train)
    this.trainPath = process.env.VUE_APP_TRAIN_PREFIX + this.curTrain.trainPath
    // }
  }

  stopConfirm() {
    const duration = getDuration(this.start_time)
    if (duration < 5) {
      this.$confirm('每次训练至少5分钟，您确定结束当前训练吗？', '专家建议', {
        confirmButtonText: '取消',
        cancelButtonText: '确定',
        type: 'warning',
      })
        .then(() => this.$message('继续训练'))
        .catch(() => this.stopTrain(this.hide))
    } else {
      this.stopTrain(this.hide)
    }
  }
  async stopTrain(done) {
    clearInterval(this.timer)
    const params = {
      id: this.id,
      trainId: this.curTrain.trainId,
      trainName: this.curTrain.trainName,
    }
    const res = await saveTrainRecord(params)
    console.log(res)
    done()
  }
  hide() {
    this.trainVisible = false
    this.handleFullscreen()
  }
  async loadingDone() {
    this.loading = false
    document.getElementById('game').focus()
    const iframe = this.$refs.iframe
    this.start_time = parseInt(Date.now() / 1000)
    await this._afterIframeLoaded()
    iframe.onerror = (message, url, row, col, error) => {
      console.log('iframe 报错')
      console.log(message, url, row, col, error)
      this.loading = false
      return true
    }
  }
  catchClick() {
    if (this.trainVisible) {
      document.getElementById('game').focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.train-list-page {
  .train-box {
    margin-top: 20px;
    background-image: url('../assets/images/index-bg.png');
    .train-container {
      .single {
        .content {
          .name {
            background: #fafafa;
          }
        }
      }
    }
  }
}
</style>
